import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useUpdateColor } from '../../../hooks/COLORS/useUpdateColor';

const UpdateColor = ({ showUpdateColor, setShowUpdateColor, color }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({ name: '', hex: '#000000' });

    const { mutateAsync: updateColor } = useUpdateColor();

    useEffect(() => {
        if (color) setFormData({ name: color.name || '', hex: color.hex || '#000000' });
    }, [color]);

    const hasChanges = color && (
        formData.name !== (color.name || '') ||
        formData.hex !== (color.hex || '#000000')
    );

    const handleSubmitForm = async (e) => {
        e.preventDefault();
        if (!formData.name.trim()) return;
        if (!hasChanges) { setShowUpdateColor(false); return; }

        // N'envoyer que les champs modifiés pour éviter le bug de validation unique côté serveur
        const colorData = {};
        if (formData.name !== (color.name || '')) colorData.name = formData.name;
        if (formData.hex !== (color.hex || '#000000')) colorData.hex = formData.hex;

        setIsSubmitting(true);
        try {
            await updateColor({ colorId: color.id, colorData });
            setShowUpdateColor(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={showUpdateColor} onHide={() => setShowUpdateColor(false)} size='md'>
            <Form onSubmit={handleSubmitForm}>
                <Modal.Header closeButton>
                    <Modal.Title><h5 className='text-muted modal-title'>Modifier la couleur</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="idName">
                        <Form.Label className='text-muted'>Nom <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="text" placeholder="Nom de la couleur" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required maxLength={100} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="idHex">
                        <Form.Label className='text-muted'>Code hexadécimal <span className="text-danger">*</span></Form.Label>
                        <div className="d-flex align-items-center gap-3">
                            <Form.Control type="color" value={formData.hex} onChange={(e) => setFormData({ ...formData, hex: e.target.value })} style={{ width: '60px', height: '40px' }} />
                            <Form.Control type="text" placeholder="#000000" value={formData.hex} onChange={(e) => setFormData({ ...formData, hex: e.target.value })} pattern="^#[0-9A-Fa-f]{6}$" maxLength={7} />
                        </div>
                        <Form.Text className="text-muted">Format: #RRGGBB (ex: #FF0000 pour rouge)</Form.Text>
                    </Form.Group>
                    <div className="mb-3">
                        <Form.Label className='text-muted'>Aperçu</Form.Label>
                        <div className="d-flex align-items-center gap-3">
                            <div style={{ width: '100px', height: '100px', borderRadius: '8px', backgroundColor: formData.hex, border: '2px solid #dee2e6', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }} />
                            <div>
                                <p className="mb-1"><strong>{formData.name || 'Nom de la couleur'}</strong></p>
                                <p className="mb-0 text-muted">{formData.hex}</p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowUpdateColor(false)} disabled={isSubmitting}>Annuler</Button>
                    <Button variant="primary" type="submit" disabled={isSubmitting || !hasChanges || !formData.name.trim()}>
                        {isSubmitting ? 'Chargement...' : 'Modifier'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default UpdateColor;